import React from 'react';
import { Button } from '@/components/ui/button';
import { Diamond, Trash2 } from 'lucide-react';
import { fmtTimePrecise } from './EditorClipTrimControls';

/**
 * Keyframe list for the selected video item's Transform (Scale/Position/
 * Rotation/Opacity). Each keyframe is a full snapshot of those four
 * properties at a timeline-relative time (0 = the item's own start); the
 * preview/render interpolate linearly between the two neighbors. Kept
 * intentionally simple for V1: add the current Transform values at the
 * playhead, or remove one — no in-place value editing, so nothing here
 * ever claims to do more than it genuinely does.
 */
export function EditorKeyframeControls({ item, localTime, onAddAtPlayhead, onRemove }) {
  if (item.item_type !== 'video') return null;
  const keyframes = [...(item.keyframes || [])].sort((a, b) => a.time_seconds - b.time_seconds);

  return (
    <div className="space-y-2 pt-2 border-t border-white/5" data-testid="keyframe-controls-panel">
      <div className="flex items-center justify-between">
        <p className="text-xs text-[#555E6E] uppercase tracking-wide flex items-center gap-1.5"><Diamond className="h-3 w-3" />Keyframes</p>
        <Button size="sm" variant="outline" className="h-6 text-[10px] border-white/10" onClick={onAddAtPlayhead} data-testid="keyframe-add-button">
          + At Playhead ({fmtTimePrecise(Math.max(0, localTime))})
        </Button>
      </div>
      {keyframes.length === 0 && (
        <p className="text-[11px] text-[#555E6E]" data-testid="keyframe-list-empty">No keyframes yet — the clip uses one fixed Transform.</p>
      )}
      <div className="space-y-1">
        {keyframes.map((kf) => (
          <div key={kf.id} className="flex items-center justify-between px-2 py-1 rounded bg-white/5 text-[11px] text-white" data-testid={`keyframe-row-${kf.id}`}>
            <span>{fmtTimePrecise(kf.time_seconds)}</span>
            <button onClick={() => onRemove(kf.id)} className="text-red-400 hover:text-red-300" data-testid={`keyframe-remove-${kf.id}`}><Trash2 className="h-3 w-3" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
